"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Router = void 0;
class Router {
    constructor(interactor) {
        this.children = [];
        this.interactable = interactor;
    }
    attachChild(router) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.children.includes(router)) {
                return;
            }
            this.children.push(router);
            yield router.interactable.activate();
            yield router.load();
        });
    }
    detachChild(router) {
        return __awaiter(this, void 0, void 0, function* () {
            yield router.unload();
            this.children = this.children.filter((i) => i !== router);
        });
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.didLoad();
        });
    }
    didLoad() {
        return __awaiter(this, void 0, void 0, function* () {
            // no-op
        });
    }
    unload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.interactable.deactivate();
            yield Promise.all(this.children.map((r) => r.unload()));
        });
    }
    switchTo(router) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._currentAttachedRouter) {
                yield this.detachChild(this._currentAttachedRouter);
                this._currentAttachedRouter = null;
            }
            yield this.attachChild(router);
            this._currentAttachedRouter = router;
        });
    }
}
exports.Router = Router;
//# sourceMappingURL=Router.js.map